import * as React from 'react';

function SvgIconReconciliationFunnel(props) {
  return (
    <svg width={15} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.756 1.408H1.253a.5.5 0 00-.43.75l3.635 6.178v3.76c0 .276.222.5.497.5h4.1a.498.498 0 00.497-.5v-3.76l3.636-6.178a.5.5 0 00-.432-.75zM8.433 11.471H5.577V9.033h2.857v2.438h-.001zm.15-3.697l-.149.26H5.575l-.148-.26-3.099-5.24h9.353l-3.098 5.24z"
        fill="currentColor"
        fillOpacity={0.85}
      />
    </svg>
  );
}

export default SvgIconReconciliationFunnel;
